import {ComponentService} from "./service/component";
import {Application} from "./application/application";
import {AccordionComponent} from "./components/accordion";

require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

(($) => $(() => {

    let components = new ComponentService();
    components.addComponent('.js-accordion', AccordionComponent, 'AccordionComponent');
    new Application(components);

}))(jQuery);
